import api from "@Api/index";
export const check = async (hashes) => {
    const { data } = await api.post(`upload/check`, hashes);
    return data;
};
